<script setup lang="ts">
import TraitCard from "@/components/user/TraitCard.vue";
import {traits} from "@/helpers/utils.ts";
import {computed} from "vue";

const {user} = defineProps(['user']);
const miroId = computed(() => {
      const profileUrl = user.meta.employee_profile;
      if (!profileUrl) return null
      const id = profileUrl.replace('https://miro.com/app/board/', '');
      user.meta.employee_profile
      return `https://miro.com/app/live-embed/${id}`
    }
);
</script>

<template>
  <div>
    <div v-if="miroId">
      <iframe width="100%" height="" class="h-[60vh]" :src="miroId" allow="fullscreen; clipboard-read; clipboard-write" allowfullscreen></iframe>

    </div>
    <div class="grid grid-cols-2 gap-2" v-else>
      <TraitCard v-for="trait in traits" :title="trait.title" :trait="user.meta[trait.key]"/>
    </div>
  </div>
</template>
